'use client';
import type { MenuChildrenDataInner } from '@generated-client/strapi';
import { SearchSidebar } from '@trwl/widgets/nav/search-sidebar';
import { NavigationSidebar } from '@trwl/widgets/nav/sidebar';

export const Sidebars = ({ menu }: { menu: MenuChildrenDataInner[] }) => {
  return (
    <>
      <NavigationSidebar.Mount menu={menu} />
      <SearchSidebar.Mount />
    </>
  );
};
